import { MOBILE } from '../../constants/breakpoints';

export const stepStyles = theme => ({
    title: {
        fontSize: 30,
        fontFamily: 'Inter, sans-serif'
    },
    stepper: {
        fontFamily: 'Inter, sans-serif',
        marginLeft: 0,
        marginRight: 0,
        paddingLeft: 0,
        paddingRight: 0,
        '& .MuiStep-root': {
            cursor: 'pointer',
            paddingRight: 0
        },
        '& .MuiStepLabel-label': {
            marginRight: '8px'
        },
        [theme.breakpoints.down(MOBILE)]: {
            backgroundColor: theme.palette.gray.light,
            padding: '16px 0'
        },
        '&.MuiPaper-root': {
            paddingBottom: '12px !important'
        }
    },
    boldSubtitle: {
        marginTop: 8,
        fontWeight: 'bold',
        fontFamily: 'Inter, sans-serif'
    },
    stepContainer: {
        display: 'flex',
        flexDirection: 'column',
        fontFamily: 'Inter, sans-serif',
        [theme.breakpoints.up(MOBILE)]: {
            marginTop: '.8rem'
        }
    },
    stepContent: {
        display: 'flex',
        flexDirection: 'column-reverse',
        width: '100%',
        fontFamily: 'Inter, sans-serif',
        [theme.breakpoints.up(MOBILE)]: {
            flexDirection: 'row',
            gap: '18px',
            maxWidth: '1440px'
        }
    },
    stepContentMain: {
        fontFamily: 'Inter, sans-serif',
        [theme.breakpoints.up(MOBILE)]: {
            flex: 1
        }
    },
    covidMessage: {
        marginTop: 8,
        marginBottom: 8,
        borderColor: '#f7d089',
        borderRadius: 10,
        backgroundColor: '#ffe36b96',
        borderWidth: '1px',
        borderStyle: 'solid',
        '& p': {
            margin: 8
        },
        '& .MuiTypography-body1': {
            color: '#373737',
            fontSize: '14px !important'
        },
        '& a': {
            color: 'blue',
            textDecoration: 'underline'
        }
    },
    previewContent: {
        display: 'flex',
        marginTop: 72,
        height: '100%',
        fontFamily: 'Inter, sans-serif',

        [theme.breakpoints.up(MOBILE)]: {
            margin: '1 .8rem 0 .8rem',
            width: '42%',
            flexShrink: 0
        }
    },
    previewContentNoNav: {
        display: 'flex',
        marginTop: 15,
        height: '100%',
        fontFamily: 'Inter, sans-serif',

        [theme.breakpoints.up(MOBILE)]: {
            margin: '1rem 0 0 0',
            width: '42%',
            flexShrink: 0
        }
    },
    detailContainer: {
        display: 'flex',
        width: '100%',
        borderRadius: 10,
        flexDirection: 'column',

        [theme.breakpoints.up(MOBILE)]: {
            width: '100%',
            border: '1px solid #ccc'
        }
    },
    detailItem: {
        display: 'flex',
        flexDirection: 'column',
        padding: '12px 16px',
        paddingTop: 0,
        paddingBottom: 0,

        '& span': {
            color: '#000000DE',
            fontSize: '16px !important'
        }
    },
    serviceName: {
        fontSize: '16px !important',
        fontWeight: 'bold'
    },
    clinicName: {
        fontSize: '16px !important',
        fontWeight: 'bold'
    },
    totalText: {
        fontSize: '16px !important',
        fontWeight: 'bold'
    },
    locationAccountName: {
        fontSize: '18px !important',
        fontWeight: 'bold'
    },
    locationAddress: {
        fontFamily: 'Inter !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
        lineHeight: '100% !important',
        letterSpacing: '0% !important',
        color: '#727272 !important'
    },
    locationSection: {
        marginBottom: '16px',
        paddingTop: '12px'
    },
    locationAccountNameSpacing: {
        marginBottom: '8px'
    },
    serviceSection: {
        marginBottom: '4px',
        paddingTop: '12px'
    },
    serviceNameSpacing: {
        marginBottom: '8px'
    },
    durationSpacing: {
        marginBottom: '8px'
    },
    practitionerSpacing: {
        marginBottom: '16px'
    },
    totalSection: {
        marginBottom: '16px',
        paddingTop: '12px'
    },
    addAnotherServiceSpacing: {
        paddingBottom: '12px'
    },
    appointmentDateSpacing: {
        paddingTop: '12px'
    },
    row: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',

        '& a': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            fontSize: '16px !important',
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    },
    practitionerRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',

        '& a': {
            color: theme.palette.primary.main,
            cursor: 'pointer',
            fontSize: '16px !important',
            '&:hover': {
                textDecoration: 'underline'
            }
        }
    },
    practitionerInfo: {
        display: 'flex',
        alignItems: 'center'
    },
    practitionerAvatar: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        marginRight: 4,
        objectFit: 'cover'
    },
    anyPractitionerIcon: {
        width: 30,
        height: 30,
        borderRadius: '50%',
        marginRight: 4,
        objectFit: 'cover'
    },
    durationContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: 6
    },
    durationText: {
        fontFamily: 'Inter !important',
        fontWeight: '500 !important',
        fontSize: '16px !important',
        lineHeight: '24px !important',
        letterSpacing: '0% !important',
        color: '#727272 !important',
        margin: '0 !important',
        padding: '0 !important',
        display: 'inline-block !important',
        verticalAlign: 'middle !important'
    },
    clockIcon: {
        width: 24,
        height: 24,
        display: 'inline-block !important',
        flexShrink: 0,
        verticalAlign: 'middle !important'
    },
    stickyNav: {
        position: 'sticky',
        top: 0,
        zIndex: 10,

        [theme.breakpoints.up(MOBILE)]: {
            position: 'initial'
        }
    },
    countdownMessage: {
        textAlign: 'center',
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#FFF',
        boxShadow: '0 2px 4px rgba(0,0,0,0.1)',

        '& span': {
            fontWeight: 'bold',
            padding: '.4rem'
        }
    },
    right: {
        float: 'right'
    },
    aBtn: {
        color: '#3083EC',
        backgroundColor: 'transparent',
        fontWeight: 'bold',
        padding: '1rem 0',
        '&:hover': {
            backgroundColor: 'transparent',
            color: '#215ba5'
        }
    },
    welcome: {
        margin: '0.5rem 0',
        color: 'grey',
        fontWeight: '500',
        fontSize: '0.85rem'
    },
    backButton: {
        display: 'flex',
        height: 'fit-content',
        alignItems: 'center',
        padding: '0 1rem',
        backgroundColor: 'transparent',
        width: 'fit-content',
        justifyContent: 'flex-start',
        color: theme.palette.primary.main,
        fontSize: '14px !important',
        '&:hover': {
            cursor: 'pointer'
        },
        [theme.breakpoints.up(MOBILE)]: {
            padding: '1rem'
        }
    },
    serviceSubtitle: {
        padding: '1rem 0 0 1rem'
    },
    widthFit: {
        width: 'fit-content'
    },
    headerWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        [theme.breakpoints.down(MOBILE)]: {
            padding: '1rem 0'
        }
    },
    deleteBtn: {
        display: 'inline-flex',
        fontSize: '18px',
        alignSelf: 'center',
        position: 'relative',
        top: '.125em'
    }
});

export const giftVoucherDialogStyles = theme => ({
    customOutlinedRoot: {
        '& .MuiOutlinedInput-root': {
            height: 'auto',
            lineHeight: '18px'
        }
    },
    button: {
        textTransform: 'none',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        margin: '.4rem 1.6rem'
    },
    customLabel: {
        '&.MuiInputLabel-outlined.MuiInputLabel-marginDense': {
            transform: 'translate(14px, 12px) scale(1)'
        }
    },
    confirm: {
        textTransform: 'none',
        backgroundColor: 'red',
        color: 'white',
        margin: '.4rem'
    },
    text: {
        fontSize: '1rem',
        color: theme.palette.black.main,
        textAlign: 'center'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '50vh'
    },
    interText700: {
        fontFamily: 'Inter',
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#000000',
        margin: '0',
        padding: '0'
    },
    emailContainer: {
        display: 'flex',
        gap: 16,
        marginTop: 20,
        flexDirection: 'row',
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        }
    }
});

export const removeServiceDialogStyles = theme => ({
    button: {
        textTransform: 'none',
        backgroundColor: theme.palette.primary.main,
        color: 'white',
        '&:hover': {
            backgroundColor: theme.palette.primary.light
        },
        margin: '.4rem'
    },
    confirm: {
        textTransform: 'none',
        backgroundColor: 'red',
        color: 'white',
        margin: '.4rem'
    },
    text: {
        fontSize: '1rem',
        color: theme.palette.black.main,
        textAlign: 'center'
    },
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: '50vh'
    },
    mobileActions: {
        textAlign: 'center'
    },
    buyNowButton: {
        color: 'white !important'
    },
    // Typography classes for consistent Inter font styling
    interText700: {
        fontFamily: 'Inter',
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#000000',
        margin: '0',
        padding: '0'
    },
    locationAccountName: {
        fontFamily: 'Inter',
        fontWeight: '700',
        fontSize: '18px',
        lineHeight: '100%',
        letterSpacing: '0%',
        color: '#000000',
        margin: '0',
        padding: '0'
    }
});
